<template>
  <TabBar activeTabName="thresholds" />
  <div class="row justify-content-center px-0 mx-0">
    <ThresholdInfo />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import ThresholdInfo from '@/components/notifications/ThresholdInfo.vue'
import TabBar from '@/components/notifications/TabBar.vue'

@Options({
  components: {
    ThresholdInfo,
    TabBar
  }
})
export default class ThresholdDetails extends Vue {}
</script>
